import { render, staticRenderFns } from "./tv-command-buttons.vue?vue&type=template&id=2bed6754&"
import script from "./tv-command-buttons.vue?vue&type=script&lang=ts&"
export * from "./tv-command-buttons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports